import * as React from "react";
import { CardType, RANKS } from "~shared/lib/CardGames";

const getSuitSymbol = (suit: string) => {
  const symbols = {
    H: "♥",
    D: "♦",
    C: "♣",
    S: "♠",
  };
  return symbols[suit as keyof typeof symbols] || suit;
};

const getSuitColor = (suit: string) => {
  return suit === "H" || suit === "D" ? "#dc2626" : "#1f2937";
};

const Card = ({ card, index }: { card: CardType; index: number }) => {
  const rank = RANKS[card.rank].short;
  const suit = getSuitSymbol(card.suit);
  const color = getSuitColor(card.suit);

  return (
    <span className="inline-block mx-1">
      <span className="relative inline-flex flex-col items-center justify-center w-16 h-20 bg-white rounded-lg shadow-lg border-1 border-gray-200">
        <span className="absolute top-1 left-1.5 flex flex-col items-center leading-none">
          <span className="text-lg font-bold" style={{ color }}>
            {rank}
          </span>
        </span>

        <span className="text-4xl" style={{ color }}>
          {suit}
        </span>
      </span>
    </span>
  );
};

export class Utils {
  static cardTextColor(card: CardType) {
    if (card.suit === "D" || card.suit === "H") return { color: "red" };
    return { color: "black" };
  }

  static prettifyCards(cards: CardType[]) {
    return (
      <span className="inline-flex flex-wrap gap-1">
        {cards.map((c, i) => (
          <Card key={`${c.suit}-${c.rank}-${i}`} card={c} index={i} />
        ))}
      </span>
    );
  }
}
